// import { Box, Grid2, Typography } from "@mui/material"
// import { Page_Padding } from "../../shared/constants"
// import CompetetionCourseCard from "../../shared/components/CompetetionCourseCard"
// import CompetionCarousel from "./CompetionCarousel"
// import CustomDivider from "../../shared/utils/CustomDivider"
// import { useApartmentListForCourse, useCourses, } from "../../assets/api/useGetApi"
// import SearchBar from "../../shared/components/SearchBar"
// import { useMemo, useState, useEffect, useRef } from "react"
// import { SkeletonCom } from "../../shared/utils/SkeletonCom"


// const CompetetionCourseListing = () => {
//     const [filters, setFilters] = useState({});

//     const {
//         flatData: eventCourses,
//         isLoading,
//         fetchNextPage,
//         hasNextPage,
//         isFetchingNextPage,
//     } = useCourses({ ...filters, course_type: "event" });
//     const sentinelRef = useRef(null);
//     useEffect(() => {
//         const sentinel = sentinelRef.current;
//         if (!sentinel) return;

//         const observer = new IntersectionObserver(
//             (entries) => {
//                 const first = entries[0];
//                 if (first.isIntersecting && hasNextPage && !isFetchingNextPage) {
//                     fetchNextPage();
//                 }
//             },
//             { threshold: 0.1 }
//         );

//         observer.observe(sentinel);
//         return () => observer.disconnect();
//     }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

//     const [searchKeyword, setSearchKeyword] = useState("");

//     const { data: apartmentList, isLoading: isLoadingApartmentList } = useApartmentListForCourse();
//     const ApartmentOptions = (apartmentList?.data || [])
//         .filter(item =>
//             ["Approved By Manager", "Accepted By Apartment", "Created"].includes(item?.terms_status)
//         )
//         .map(item => ({
//             id: item?.id,
//             label: item?.apartment_name,
//             value: item?.apartment_name,
//         }));
//     const filteredCandidates = useMemo(() => {
//         if (!eventCourses) return [];
//         if (!searchKeyword.trim()) return eventCourses;

//         return eventCourses.filter(item =>
//             item.title?.toLowerCase().includes(searchKeyword.trim().toLowerCase())
//         );
//     }, [eventCourses, searchKeyword]);

//     return (
//         <Box className="body contact_us" px={Page_Padding}>
//             <CompetionCarousel />
//             <CustomDivider />
//             <Typography variant="h4" mb={2}>Play, Laugh, Create!</Typography>
//             <Typography variant='body1' color='grey.600' fontWeight={200}>Get ready for hours of joy with our handpicked activities designed to inspire and entertain.</Typography>
//             <CustomDivider />
//             <Grid2 container>
//                 <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
//                     <SearchBar
//                         studentOptions={eventCourses?.map(c => ({
//                             id: c.id,
//                             label: c.title
//                         })) || []}
//                         apartmentOptions={ApartmentOptions}
//                         onSearch={(keyword) => {
//                             setSearchKeyword(keyword || "");
//                         }}
//                         onApartmentSelect={(apartmentId) => {
//                             setFilters(prev => ({ ...prev, apartment_id: apartmentId || undefined }));
//                         }}
//                         placeholder={"Search By Course Name"}
//                     />

//                 </Grid2>
//             </Grid2>

//             <Grid2 container spacing={5}>
//                 {isLoading ? (
//                     [...Array(6)].map((_, index) => (
//                         <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={index}>
//                             <SkeletonCom />
//                         </Grid2>
//                     ))
//                 ) : filteredCandidates.length === 0 ? (
//                     <Box textAlign="center" width="100%">
//                         <Typography variant='h6'>Course not found.</Typography>
//                     </Box>
//                 ) : (
//                     filteredCandidates.map((item, index) => (
//                         <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={index}>
//                             <CompetetionCourseCard item={item} key={index} />
//                         </Grid2>
//                     ))
//                 )}
//             </Grid2>

//             <Box ref={sentinelRef} sx={{ height: "40px", mt: 2 }} />
//             {isFetchingNextPage && (
//                 <Grid2 container spacing={5}>
//                     {[...Array(3)].map((_, index) => (
//                         <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={index}>
//                             <SkeletonCom />
//                         </Grid2>
//                     ))}
//                 </Grid2>
//             )}




//         </Box>
//     )
// }

// export default CompetetionCourseListing



import { Box, Grid2, Typography } from "@mui/material";
import { Page_Padding } from "../../shared/constants";
import CompetetionCourseCard from "../../shared/components/CompetetionCourseCard";
import CompetionCarousel from "./CompetionCarousel";
import CustomDivider from "../../shared/utils/CustomDivider";
import {
  useApartmentListForCourse,
  useCourses,
} from "../../assets/api/useGetApi";
import SearchBar from "../../shared/components/SearchBar";
import { useMemo, useState, useEffect, useRef } from "react";
import { SkeletonCom } from "../../shared/utils/SkeletonCom";
import { useDebounce } from "../../shared/hook/useDebounce";

const CompetetionCourseListing = () => {
  const [filters, setFilters] = useState({});
  const [searchKeyword, setSearchKeyword] = useState("");

  // ✅ debounce search (performance)
  const debouncedSearch = useDebounce(searchKeyword, 300);

  const {
    flatData: eventCourses,
    isLoading,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
  } = useCourses({ ...filters, course_type: "event" });

  // ✅ infinite scroll ref
  const sentinelRef = useRef(null);

  useEffect(() => {
    const sentinel = sentinelRef.current;
    if (!sentinel) return;

    const observer = new IntersectionObserver(
      (entries) => {
        const first = entries[0];
        if (first.isIntersecting && hasNextPage && !isFetchingNextPage) {
          fetchNextPage();
        }
      },
      {
        threshold: 0.1,
        rootMargin: "200px", // ✅ preload before bottom
      }
    );

    observer.observe(sentinel);
    return () => observer.disconnect();
  }, [hasNextPage, isFetchingNextPage, fetchNextPage]);

  // ✅ apartment list
  const { data: apartmentList } = useApartmentListForCourse();

  const ApartmentOptions = (apartmentList?.data || [])
    .filter((item) =>
      ["Approved By Manager", "Accepted By Apartment", "Created"].includes(
        item?.terms_status
      )
    )
    .map((item) => ({
      id: item?.id,
      label: item?.apartment_name,
      value: item?.apartment_name,
    }));

  // ✅ filter courses
  const filteredCandidates = useMemo(() => {
    if (!eventCourses) return [];
    if (!debouncedSearch.trim()) return eventCourses;

    return eventCourses.filter((item) =>
      item.title?.toLowerCase().includes(debouncedSearch.toLowerCase())
    );
  }, [eventCourses, debouncedSearch]);

  return (
    <Box className="body contact_us" px={Page_Padding}>
      <CompetionCarousel />
      <CustomDivider />

      <Typography variant="h4" mb={2}>
        Play, Laugh, Create!
      </Typography>
      <Typography variant="body1" color="grey.600" fontWeight={200}>
        Get ready for hours of joy with our handpicked activities designed to
        inspire and entertain.
      </Typography>

      <CustomDivider />

      {/* 🔍 Search + filter */}
      <Grid2 container>
        <Grid2 size={{ xs: 12, sm: 6, md: 6 }}>
          <SearchBar
            studentOptions={
              eventCourses?.map((c) => ({
                id: c.id,
                label: c.title,
              })) || []
            }
            apartmentOptions={ApartmentOptions}
            onSearch={(keyword) => {
              setSearchKeyword(keyword || "");
            }}
            onApartmentSelect={(apartmentId) => {
              setFilters((prev) => ({
                ...prev,
                apartment_id: apartmentId || undefined,
              }));
            }}
            placeholder={"Search By Course Name"}
          />
        </Grid2>
      </Grid2>

      {/* 📦 Course grid */}
      <Grid2 container spacing={5}>
        {isLoading ? (
          [...Array(6)].map((_, index) => (
            <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <SkeletonCom />
            </Grid2>
          ))
        ) : filteredCandidates.length === 0 ? (
          <Box textAlign="center" width="100%">
            <Typography variant="h6">Course not found.</Typography>
          </Box>
        ) : (
          filteredCandidates.map((item, index) => (
            <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={item.id || index}>
              <CompetetionCourseCard item={item} />
            </Grid2>
          ))
        )}
      </Grid2>

      {/* 🔄 Infinite scroll trigger */}
      <Box ref={sentinelRef} sx={{ height: "40px", mt: 2 }} />

      {/* ⏳ Next page loader */}
      {isFetchingNextPage && (
        <Grid2 container spacing={5}>
          {[...Array(3)].map((_, index) => (
            <Grid2 size={{ xs: 12, sm: 6, md: 4 }} key={index}>
              <SkeletonCom />
            </Grid2>
          ))}
        </Grid2>
      )}
    </Box>
  );
};

export default CompetetionCourseListing;
